/*jshint browserify: true */
'use strict';

/**
 * A rectangle on the PDF page.
 * Provides coordinate properties for:
 *   - PDF. Position on the page, note that on a PDF, 0,0 is bottom-right.
 *   - Viewport. Position on the viewport HTML element.
 */
var Rectangle = (function RectangleClosure() {
    function Rectangle(pdfLeft, pdfBottom, pdfWidth, pdfHeight, pdfViewport) {

        Object.defineProperty(this, 'pdfLeft', {
            get: function () {
                return pdfLeft;
            }
        });
        Object.defineProperty(this, 'pdfBottom', {
            get: function () {
                return pdfBottom;
            }
        });
        Object.defineProperty(this, 'pdfWidth', {
            get: function () {
                return pdfWidth;
            }
        });
        Object.defineProperty(this, 'pdfHeight', {
            get: function () {
                return pdfHeight;
            }
        });

        Object.defineProperty(this, 'viewportLeft', {
            get: function () {
                return pdfLeft * pdfViewport.scale;
            }
        });
        Object.defineProperty(this, 'viewportTop', {
            get: function () {
                return ((pdfViewport.height / pdfViewport.scale) - pdfBottom - pdfHeight) * pdfViewport.scale;
            }
        });
        Object.defineProperty(this, 'viewportWidth', {
            get: function () {
                return pdfWidth * pdfViewport.scale;
            }
        });
        Object.defineProperty(this, 'viewportHeight', {
            get: function () {
                return pdfHeight * pdfViewport.scale;
            }
        });
    }

    Rectangle.prototype = {
        /**
         * @param {PDFedit.coordinates.Position} position
         * @returns {bool} true if provided position is inside the rectangle
         */
        positionIsInsideRectangle: function (position) {
            return position.pdfX >= this.pdfLeft &&
                position.pdfX <= this.pdfLeft + this.pdfWidth &&
                position.pdfY >= this.pdfBottom &&
                position.pdfY <= this.pdfBottom + this.pdfHeight;
        }
    };

    /**
     * Create a rectangle from the provided positions. Positions must specify opposite corners
     * of the rectangle.
     *
     * @param {PDFedit.coordinates.Position} positionOne
     * @param {PDFedit.coordinates.Position} positionTwo
     * @param {PageViewport} pdfViewport - A PDF.JS PageViewport object
     */
    Rectangle.fromPositions = function (positionOne, positionTwo, pdfViewport) {
        var x, y, width, height;

        if (positionOne.pdfX < positionTwo.pdfX) {
            x = positionOne.pdfX;
            width = positionTwo.pdfX - positionOne.pdfX;
        } else {
            x = positionTwo.pdfX;
            width = positionOne.pdfX - positionTwo.pdfX;
        }

        if (positionOne.pdfY < positionTwo.pdfY) {
            y = positionOne.pdfY;
            height = positionTwo.pdfY - positionOne.pdfY;
        } else {
            y = positionTwo.pdfY;
            height = positionOne.pdfY - positionTwo.pdfY;
        }

        return new Rectangle(x, y, width, height, pdfViewport);
    };

    return Rectangle;
})();

module.exports = Rectangle;